<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content
        div.modal-body
          p 新增使用者
            span.icon-right(@click="$emit('closeForm')") X
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 帳號*
              input.form-control(v-model="username")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 密碼*
              input.form-control(type="password" v-model="password")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 再次輸入密碼* 
              input.form-control(type="password" v-model="password2")
          div.form-group
            div.form-row
              div.input-group.col-6
                div.input-group-prepend
                  span.input-group-text 姓*
                input.form-control(type="text" v-model="lastName")
              div.input-group.col-6
                div.input-group-prepend
                  span.input-group-text 名*
                input.form-control(type="text" v-model="firstName")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 警員代碼*
              input.form-control(type="text" v-model="loginBarcode") 
          div.form-group
            div.form-row
              div.input-group.col-6
                div.input-group-prepend
                  span.input-group-text 職稱*
                select.form-control(v-model="jobTitle")
                  option(v-for="job in jobTitles" :value="job.id") {{job.name}}
              div.input-group.col-6
                div.input-group-prepend
                  span.input-group-text 單位*
                select.form-control(v-model="department")
                  option(v-for="dep in departments" :value="dep.id") {{dep.name}}
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 後台操作權限*
              select.form-control(v-model="serverPrivilege2Group")
                option(v-for="privilege in serverPrivilege2Groups" :value="privilege.id") {{privilege.name}} 
          div.form-check
            input.form-check-input(type="checkbox" id="backManage" v-model="backManage")
            label.form-check-label(for="backManage") 能否後台設定

          hr
          span.errorMsg {{ formMsg }}
          button.btn.btn-secondary.float-right(
            :disabled="formComplete === false"
            @click.prevent="createNewUser"
            ) 新增
</template>

<script>
export default {
  name: 'CreateUserForm',
  data() {
    return {
      username: null,
      password: null,
      password2: null,
      jobTitle: null,
      jobTitles: [],
      department: null,
      departments: [],
      loginBarcode: null,
      //medAppPrivilegeGroups: [],
      //medAppPrivilegeGroup: "全部功能",
      serverPrivilege2Groups: [],
      serverPrivilege2Group: "後台操作權限",
      firstName: '',
      lastName: '',
      loginBackCheck: true,
      backManage: false,
      formMsg: '請填入所有資訊以新增',
    };
  },
  created() {
    this.getJobTitle();
    this.getDepartment();
    //this.getMedAppPrivilegeGroup();
    this.getServerPrivilege2Group();
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    formComplete() {
      if (this.username === null) return false;
      if (this.password === null) return false;
      if (this.password2 === null) return false;
      if (this.jobTitle === null) return false;
      if (this.department === null) return false;
      if (this.loginBarcode === null) return false;
      if (this.firstName === '') return false;
      if (this.lastName === '') return false;
      if (this.password !== this.password2) return false;
      return true;
    },
  },
  methods: {
    createNewUser() {
      if (this.password === this.password2) {
        this.instance.post('/api/user/', {
          username: this.username,
          password: this.password,
          first_name: this.firstName,
          last_name: this.lastName,
          barcode: this.loginBarcode,
          department: this.department,
          title: this.jobTitle,
          //med_app_privilege: this.medAppPrivilegeGroup,
          server_privilege2: this.serverPrivilege2Group,
          is_admin: this.loginBackCheck,
          is_superuser: this.backManage,
        })
        .then(() => {
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '新增成功',
          });
          this.$emit('closeForm');
          this.$parent.$refs.vuetable.refresh();
        })
        .catch((err) => {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: err.response.data,
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認密碼一致',
        });
      }
    },
    getDepartment() {
      return this.instance.get('/api/department/')
      .then((res) => {
        this.putIntoData(res, 'departments');
      });
    },
    getJobTitle() {
      return this.instance.get('/api/job-title/')
      .then((res) => {
        this.putIntoData(res, 'jobTitles');
      });
    },
    putIntoData(response, data) {
      response.data.forEach((item) => {
        this[data].push(item);
      });
    },
    /*
    getMedAppPrivilegeGroup() {
      this.instance.get('/api/med-app-privilege/')
      .then((res) => {
        this.putIntoData(res, 'medAppPrivilegeGroups');
      });
    },
    */
    getServerPrivilege2Group() {
      this.instance.get('/api/server-privilege2/')
      .then((res) => {
        this.putIntoData(res, 'serverPrivilege2Groups');
      });
    },
  },
  watch: {
    password2(val) {
      if (val !== this.password) {
        this.formMsg = '請確認密碼一致';
      } else {
        this.formMsg = '';
      }
    },
  },
};
</script>

<style lang="sass">

.errorMsg
  color: red
</style>




// WEBPACK FOOTER //
// CreateUserForm.vue?57c36db2